<template>
  <div class="list">
    <header class="list-header">
      <input type="text" placeholder="Vem söker du?" class="filter-box" v-model="activeFilter" />
    </header>
    <ul class="player-list">
      <li class="player-item" v-for="player in filteredList" @click="showPlayer(player.id)" :key="player.id">  <div class="avatar" :style="{'background-image': 'url('+player.image+')'}"></div>
        <h3>{{player.name}}</h3>

      </li>
    </ul>
  </div>
</template>

<script>

  import {mapState} from 'vuex';

  export default {
    data: function(){
      return {
        activeFilter: ""
      }
    }, 
    mounted: function(){
      this.$store.dispatch('fetchList')
    }, 
    computed: {
      ...mapState(['list']),
      filteredList: function(){
        if(this.list){
          return this.list.filter((item) => {
            if(this.activeFilter.length){
              return item.name.toLowerCase().match(this.activeFilter.toLowerCase())
            }else{
              return true;
            }
          })
        }else{
          return []
        }
      }
    }, 
    methods: {
      showPlayer: function(id){
        this.$router.push('/player/'+id)
      }
    }
  }

</script>